import { useContextSelector } from 'use-context-selector';

import { ListingTableActionContext } from './ListingTableActionContext';
import {
  SubmitListingPriceParams,
  SubmitPricingSettingsParams,
} from './ListingTableActionContext.types';

export const useListingTableActionContextSubmitListingPriceChangeSelector =
  (): ((params: SubmitListingPriceParams) => void) =>
    useContextSelector(
      ListingTableActionContext,
      (context) => context.onSubmitListingPriceChange
    );

export const useListingTableActionContextSubmitPricingSettingsChangeSelector =
  (): ((params: SubmitPricingSettingsParams) => void) =>
    useContextSelector(
      ListingTableActionContext,
      (context) => context.onSubmitPricingSettingsChange
    );
